import React from 'react'
import CommunityPostsListing from './CommunityPostsListing'

const CommunityTopPlayers = () => (
  <CommunityPostsListing
    postType="round_top_players"
    title="Top Players Posts"
    subtitle="The highest-scoring players shared after each round."
  />
)

export default CommunityTopPlayers
